import { render, staticRenderFns } from "./DRadioPreview.vue?vue&type=template&id=2ff6ad90&"
import script from "./DRadioPreview.vue?vue&type=script&lang=js&"
export * from "./DRadioPreview.vue?vue&type=script&lang=js&"
import style0 from "./DRadioPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports